import * as React from 'react';
export var RootContext = /*#__PURE__*/React.createContext({
  disabledSocials: [],
  showLogo: true,
  frameless: false,
  isRedesignExperimentEnabled: false
});